<template>

<div v-if="!isMobile">
  <nav>
<v-app-bar app>
      <v-toolbar-title><v-breadcrumbs
      :items="items"
      large
    ></v-breadcrumbs></v-toolbar-title>
      <v-spacer></v-spacer>
   <div class="pa-1">
   <v-select
          :items="location"
          item-value="_id"
          v-model="locationItem"
          @change="updateLocation"
          hide-details
          :item-text="
                        (location) => {
                          return (
                              location.location
                          );
                          }
                        "
          prepend-icon="mdi-map-marker"
          solo
          style="font-size: 15px;"
        ></v-select>
   </div>
 <v-md-date-range-picker
                :presets="presets"
                opens="right"
                @change="updateData"
              >
                <v-card class="pa-3" tile slot="input"
                  ><v-icon color="red darken-2"> mdi-clock-outline </v-icon> <span style="font-size: 15px;">{{ formatDate(values1) }} - </span>
                  <span style="font-size: 15px;" v-if="values2 > Date.now()">Now</span><span style="font-size: 15px;" v-else> {{ formatDate(values2) }}</span>
                </v-card>
              </v-md-date-range-picker>
              <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
             <v-btn
      :loading="loading5"
      :disabled="loading5"
      :color="!timer ? 'red' : 'green'"
      :class="!timer ? 'ma-1 white--text' : 'ma-1 white--text' "
      @click="timer = !timer, loader = 'loading5'"
      fab
      small
      v-bind="attrs"
      v-on="on" 
    >
      <v-icon dark>
        {{ !timer ? 'mdi-play' : 'mdi-pause' }}
      </v-icon>
    </v-btn>
     </template>
      <span> {{ !timer ? 'Enable Auto Refresh Page' : 'Disable Auto Refresh Page' }}</span>
    </v-tooltip>
    </v-app-bar>
  </nav>

  <div>
  <v-container class="d-flex flex-column justify-space-between align-center" v-if="this.airQualityCo2.length == 0 && this.airQualityWeather.length == 0">
  <v-img
  centered
  max-height="700"
  max-width="700"
  src="https://www.edgecrm.app/images/no-data.gif"
></v-img>
<p>No Data Please Try Another Location</p>
</v-container>
  <v-row v-if="this.airQualityCo2.length != 0">
    <div style="padding-left: 25px; padding-top: 25px;">
      <v-card width="750"> 
         <v-card-title><v-icon
      large
      color="green darken-2">mdi-molecule-co2
      </v-icon>CO2 Chart</v-card-title>
         <v-card-subtitle>
          <p style="padding-left: 36px;">Recently: {{this.co2[0]}} ppm 
            <span style="color:green" v-if="this.co2[0] >= 250 && this.co2[0] <= 1000">Good</span>
          <span style="color:blue" v-if="this.co2[0] >= 1000 && this.co2[0] <= 2000">Average</span>
          <span style="color:red lighten-3" v-if="this.co2[0] >= 2000 && this.co2[0] <= 5000">Poor</span>
          <span style="color:red" v-if="this.co2[0] >= 5000">Hazard</span></p>
          </v-card-subtitle> 
          <v-flex xs12>
          <v-row>
            <v-col>  
      <apexchart width="500" height="220" type="line" :options="co2Chart" :series="co2Series"></apexchart>
            </v-col>
            <v-col>
                <v-card-actions>
                  <v-btn flat color="red">Max</v-btn>
                  <v-btn flat color="white"
                    >{{Math.max.apply(Math,this.co2)}} ppm</v-btn
                  >
                </v-card-actions>
                <v-card-actions>
                  <v-btn flat color="blue lighten-2">Avg</v-btn>
                  <v-btn flat color="white"
                    >{{(this.co2.reduce((a, b) => a + b, 0) / this.co2.length).toFixed(0)}} ppm</v-btn
                  >
                </v-card-actions>
                <v-card-actions>
                  <v-btn flat color="blue">Min</v-btn>
                  <v-btn flat color="white"
                    >{{Math.min.apply(Math,this.co2)}} ppm</v-btn>
                </v-card-actions>
       
              </v-col>
          </v-row>
          </v-flex>
      </v-card>
    </div>
  </v-row>

    <v-row v-if="this.airQualityWeather.length != 0">
      <div style="padding-left: 25px; padding-top: 25px;">
      <v-card width="750">
        <v-card-title><v-icon
      large
      color="red darken-2">mdi-thermometer
      </v-icon>Temperature Chart</v-card-title>
         <v-card-subtitle>
          <p style="padding-left: 40px;">Recently: {{this.temp[0]}} °C 
            <span style="color:grey" v-if="this.temp[0] <=35.5">Low</span>
          <span style="color:green" v-if="this.temp[0] >35.5 && this.temp[0] <=37.2">Normal</span>
          <span style="color:red" v-if="this.temp[0] >37.2">High</span>
          </p>
          </v-card-subtitle>  
          <v-flex xs12>
          <v-row>
            <v-col>       
      <apexchart width="500" height="220" type="line" :options="tempChart" :series="tempSeries"></apexchart>
            </v-col>
              <v-col>
                <v-card-actions>
                  <v-btn flat color="red">Max</v-btn>
                  <v-btn flat color="white"
                    >{{Math.max.apply(Math,this.temp)}} °C</v-btn
                  >
                </v-card-actions>
                <v-card-actions>
                  <v-btn flat color="blue lighten-2">Avg</v-btn>
                  <v-btn flat color="white"
                    >{{(this.temp.reduce((a, b) => a + b, 0) / this.temp.length).toFixed(2)}} °C</v-btn
                  >
                </v-card-actions>
                <v-card-actions>
                  <v-btn flat color="blue">Min</v-btn>
                  <v-btn flat color="white"
                    >{{Math.min.apply(Math,this.temp)}} °C</v-btn>
                </v-card-actions>
              </v-col>
          </v-row>
          </v-flex>
       </v-card>
  
      </div>
  </v-row>

  <v-row v-if="this.airQualityWeather.length != 0">
 <div style="padding-left: 25px; padding-top: 25px; padding-bottom: 25px;">
      <v-card width="750">   
      <v-card-title>
      <v-icon
      large
      color="blue darken-2">mdi-water-percent
      </v-icon>Humidity Chart</v-card-title>
         <v-card-subtitle>
          <p style="padding-left: 36px;">Recently: {{this.humid[0]}} %RH 
            <span style="color:red" v-if="this.humid[0] <=30">Too Dry</span>
          <span style="color:green" v-if="this.humid[0] >30 && this.humid[0] <=60">Optimum</span>
          <span style="color:blue" v-if="this.humid[0] >60 && this.humid[0] <=100">Too Moist</span>
          </p>
          </v-card-subtitle>
          <v-flex xs12>
          <v-row>
            <v-col>    
      <apexchart width="500" height="220" type="line" :options="humidChart" :series="humidSeries"></apexchart>
            </v-col>
             <v-col>
      <v-card-actions>
                  <v-btn flat color="red">Max</v-btn>
                  <v-btn flat color="white"
                    >{{Math.max.apply(Math,this.humid)}} %RH</v-btn
                  >
                </v-card-actions>
                <v-card-actions>
                  <v-btn flat color="blue lighten-2">Avg</v-btn>
                  <v-btn flat color="white"
                    >{{(this.humid.reduce((a, b) => a + b, 0) / this.humid.length).toFixed(2)}} %RH</v-btn
                  >
                </v-card-actions>
                <v-card-actions>
                  <v-btn flat color="blue">Min</v-btn>
                  <v-btn flat color="white"
                    >{{Math.min.apply(Math,this.humid)}} %RH</v-btn>
                </v-card-actions>
      </v-col>
          </v-row>
          </v-flex>
         </v-card>
 </div>
  </v-row>
 </div>
</div>

<div v-else>
  <v-container>
    <v-row>
      <div class="pa-1">
   <v-select
          :items="location"
          item-value="_id"
          v-model="locationItem"
          @change="updateLocation"
          hide-details
          :item-text="
                        (location) => {
                          return (
                              location.location
                          );
                          }
                        "
          prepend-icon="mdi-map-marker"
          solo
          style="font-size: 12px;"
        ></v-select>
   </div>
   <v-container>
 <v-md-date-range-picker
                :presets="presets"
                opens="right"
                @change="updateData"
              >
                <v-card class="pa-3" tile slot="input"
                  > <v-icon color="red darken-2"> mdi-clock-outline </v-icon><span style="font-size: 12px;">{{ formatDate(values1) }} - </span>
                  <span style="font-size: 12px;" v-if="values2 > Date.now()">Now</span><span style="font-size: 12px;" v-else> {{ formatDate(values2) }}</span>
                </v-card>
              </v-md-date-range-picker>
              <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
             <v-btn
      :loading="loading5"
      :disabled="loading5"
      :color="!timer ? 'red' : 'green'"
      :class="!timer ? 'ma-1 white--text' : 'ma-1 white--text' "
      @click="timer = !timer, loader = 'loading5'"
      fab
      small
      v-bind="attrs"
      v-on="on" 
    >
      <v-icon dark>
        {{ !timer ? 'mdi-play' : 'mdi-pause' }}
      </v-icon>
    </v-btn>
     </template>
      <span> {{ !timer ? 'Enable Auto Refresh Page' : 'Disable Auto Refresh Page' }}</span>
    </v-tooltip>
   </v-container>
    </v-row>
  </v-container>
  <v-container>
  <div>
   <v-container class="d-flex flex-column justify-space-between align-center" v-if="this.airQualityCo2.length == 0 && this.airQualityWeather.length == 0">
  <v-img
  centered
  max-height="700"
  max-width="400"
  src="https://www.edgecrm.app/images/no-data.gif"
></v-img>
<p style="font-size: 12px;">No Data Please Try Another Location</p>
</v-container>
  <v-row v-if="this.airQualityCo2.length != 0">
    <div style="padding-left: 10px;">
      <v-card width="450"> 
         <v-card-title style="font-size: 12px"><v-icon
      color="green darken-2">mdi-molecule-co2
      </v-icon>CO2 Chart</v-card-title>
         <v-card-subtitle>
          <p style="font-size: 12px">Recently: {{this.co2[0]}} ppm 
            <span style="color:green" v-if="this.co2[0] >= 250 && this.co2[0] <= 1000">Good</span>
          <span style="color:blue" v-if="this.co2[0] >= 1000 && this.co2[0] <= 2000">Average</span>
          <span style="color:red lighten-3" v-if="this.co2[0] >= 2000 && this.co2[0] <= 5000">Poor</span>
          <span style="color:red" v-if="this.co2[0] >= 5000">Hazard</span></p>
          </v-card-subtitle> 
          <v-flex xs12>
          <v-row>
            <v-col>  
      <apexchart width="400" height="180" type="line" :options="co2Chart" :series="co2Series"></apexchart>
            </v-col>
            <v-col>
                <v-card-actions class="justify-center">
                  <v-btn flat color="red" style="font-size: 12px">Max</v-btn>
                  <v-btn flat color="white" style="font-size: 12px"
                    >{{Math.max.apply(Math,this.co2)}} ppm</v-btn
                  >
                </v-card-actions>
                <v-card-actions class="justify-center">
                  <v-btn flat color="blue lighten-2" style="font-size: 12px">Avg</v-btn>
                  <v-btn flat color="white" style="font-size: 12px"
                    >{{(this.co2.reduce((a, b) => a + b, 0) / this.co2.length).toFixed(0)}} ppm</v-btn
                  >
                </v-card-actions>
                <v-card-actions class="justify-center">
                  <v-btn flat color="blue" style="font-size: 12px">Min</v-btn>
                  <v-btn flat color="white" style="font-size: 12px"
                    >{{Math.min.apply(Math,this.co2)}} ppm</v-btn>
                </v-card-actions>
       
              </v-col>
          </v-row>
          </v-flex>
      </v-card>
    </div>
  </v-row>

    <v-row v-if="this.airQualityWeather.length != 0">
      <div style="padding-left: 10px; padding-top: 10px;">
      <v-card width="450">
        <v-card-title style="font-size: 12px"><v-icon
      color="red darken-2">mdi-thermometer
      </v-icon>Temperature Chart</v-card-title>
         <v-card-subtitle>
          <p style="font-size: 12px">Recently: {{this.temp[0]}} °C 
            <span style="color:grey" v-if="this.temp[0] <=35.5">Low</span>
          <span style="color:green" v-if="this.temp[0] >35.5 && this.temp[0] <=37.2">Normal</span>
          <span style="color:red" v-if="this.temp[0] >37.2">High</span>
          </p>
          </v-card-subtitle>  
          <v-flex xs12>
          <v-row>
            <v-col>       
      <apexchart width="400" height="180" type="line" :options="tempChart" :series="tempSeries"></apexchart>
            </v-col>
              <v-col>
                <v-card-actions class="justify-center">
                  <v-btn flat color="red" style="font-size: 12px">Max</v-btn>
                  <v-btn flat color="white" style="font-size: 12px"
                    >{{Math.max.apply(Math,this.temp)}} °C</v-btn
                  >
                </v-card-actions>
                <v-card-actions class="justify-center">
                  <v-btn flat color="blue lighten-2" style="font-size: 12px">Avg</v-btn>
                  <v-btn flat color="white" style="font-size: 12px"
                    >{{(this.temp.reduce((a, b) => a + b, 0) / this.temp.length).toFixed(2)}} °C</v-btn
                  >
                </v-card-actions>
                <v-card-actions class="justify-center">
                  <v-btn flat color="blue" style="font-size: 12px">Min</v-btn>
                  <v-btn flat color="white" style="font-size: 12px"
                    >{{Math.min.apply(Math,this.temp)}} °C</v-btn>
                </v-card-actions>
              </v-col>
          </v-row>
          </v-flex>
       </v-card>
  
      </div>
  </v-row>

  <v-row v-if="this.airQualityWeather.length != 0">
 <div style="padding-left: 10px; padding-top: 10px; padding-bottom: 25px;">
      <v-card width="450">   
      <v-card-title style="font-size: 12px">
      <v-icon
      color="blue darken-2">mdi-water-percent
      </v-icon>Humidity Chart</v-card-title>
         <v-card-subtitle>
          <p style="font-size: 12px">Recently: {{this.humid[0]}} %RH 
            <span style="color:red" v-if="this.humid[0] <=30">Too Dry</span>
          <span style="color:green" v-if="this.humid[0] >30 && this.humid[0] <=60">Optimum</span>
          <span style="color:blue" v-if="this.humid[0] >60 && this.humid[0] <=100">Too Moist</span>
          </p>
          </v-card-subtitle>
          <v-flex xs12>
          <v-row>
            <v-col>    
      <apexchart width="400" height="180" type="line" :options="humidChart" :series="humidSeries"></apexchart>
            </v-col>
             <v-col>
      <v-card-actions class="justify-center">
                  <v-btn flat color="red" style="font-size: 12px">Max</v-btn>
                  <v-btn flat color="white" style="font-size: 12px"
                    >{{Math.max.apply(Math,this.humid)}} %RH</v-btn
                  >
                </v-card-actions>
                <v-card-actions class="justify-center">
                  <v-btn flat color="blue lighten-2" style="font-size: 12px">Avg</v-btn>
                  <v-btn flat color="white" style="font-size: 12px"
                    >{{(this.humid.reduce((a, b) => a + b, 0) / this.humid.length).toFixed(2)}} %RH</v-btn
                  >
                </v-card-actions>
                <v-card-actions class="justify-center">
                  <v-btn flat color="blue" style="font-size: 12px">Min</v-btn>
                  <v-btn flat color="white" style="font-size: 12px"
                    >{{Math.min.apply(Math,this.humid)}} %RH</v-btn>
                </v-card-actions>
      </v-col>
          </v-row>
          </v-flex>
         </v-card>
 </div>
  </v-row>
 </div>
  </v-container>
</div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import moment from 'moment';
import VueApexCharts from 'vue-apexcharts'

Vue.component("apexchart", VueApexCharts);

export default {
  data: () => ({
    items: [
        {
          text: 'Dashboard',
          disabled: false,
          href: '/',
        },
        {
          text: 'Air Quality',
          disabled: true,
          href: '',
        },
        {
          text: 'AQ By Location',
          disabled: true,
          href: '',
        } 
      ],
      values1: moment().subtract(24, "hour"),
      values2: moment().endOf("day"),
      presets: [
        {
          label: "Last 1 Hour",
          range: [moment().subtract(1, "hour"), moment().endOf("day")],
        },
        {
          label: "Last 3 Hour",
          range: [moment().subtract(3, "hour"), moment().endOf("day")],
        },
        {
          label: "Last 12 Hour",
          range: [moment().subtract(12, "hour"), moment().endOf("day")],
        },
        {
          label: "Today",
          range: [moment().startOf("day"), moment().endOf("day")],
        },
        {
          label: "This Week",
          range: [moment().subtract(6, "day"), moment().endOf("day")],
        },
        {
          label: "Last Week",
          range: [moment().subtract(13, "day").startOf("day"), moment().subtract(7, "day").endOf("day")],
        },
        {
          label: "This Month",
          range: [moment().startOf("month").startOf("day"), moment().endOf("month")],
        },
        {
          label: "Last Month",
          range: [moment().subtract(2, "month").startOf("day"), moment().subtract(1, "month").endOf("day")],
        },
      ],
    timer: true,
    loader: null,
    loading5: false,
    isMobile: true,
    airQualityCo2:[],
    airQualityWeather:[],
    co2: [],
    temp: [],
    humid: [],

    location: [],
    locationItem: [],

    co2Chart: {
     chart: {
        type: "line",
        animations: {
            enabled: false
        }
        },
        markers: {
          size: 0
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          type: "datetime",
          labels: {
            datetimeUTC: false,
          },
        },

        tooltip: {
          x: {
            format: "dd MMM yyyy hh:mm:ss tt",
          },
        },
        legend: {
          show: false,
          showForSingleSeries: true,
          position: "top",
        },
        yaxis: {
      axisTicks: {
        show: true
      },
      labels: {
        formatter: (val) => { return val + ' ppm' },
      },
    },
    stroke: {
    show: true,
    curve: 'smooth',
    lineCap: 'butt',
    colors: undefined,
    width: 2,
    dashArray: 0,      
    },
      },
      co2Series: [
        {
          data: [],
        },
      ],

    tempChart: {
     chart: {
        type: "line",
        animations: {
            enabled: false
        }
        },
        markers: {
          size: 0
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          type: "datetime",
          labels: {
            datetimeUTC: false,
          },
        },

        tooltip: {
          x: {
            format: "dd MMM yyyy hh:mm:ss tt",
          },
        },
        legend: {
          show: false,
          showForSingleSeries: true,
          position: "top",
        },
        yaxis: {
      axisTicks: {
        show: true
      },
      labels: {
        formatter: (val) => { return val.toFixed(2) + ' °C' },
      },
    },
    stroke: {
    show: true,
    curve: 'smooth',
    lineCap: 'butt',
    colors: undefined,
    width: 2,
    dashArray: 0,      
    },
      },
      tempSeries: [
        {
          data: [],
        },
      ],

    humidChart: {
     chart: {
        type: "line",
        animations: {
            enabled: false
        }
        },
        markers: {
          size: 0
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          type: "datetime",
          labels: {
            datetimeUTC: false,
          },
        },

        tooltip: {
          x: {
            format: "dd MMM yyyy hh:mm:ss tt",
          },
        },
        legend: {
          show: false,
          showForSingleSeries: true,
          position: "top",
        },
      yaxis: {
      axisTicks: {
        show: true
      },
      labels: {
        formatter: (val) => { return val.toFixed(2) + ' %RH' },
      },
    },
    stroke: {
    show: true,
    curve: 'smooth',
    lineCap: 'butt',
    colors: undefined,
    width: 2,
    dashArray: 0,      
    },
      },
    humidSeries: [
        {
          data: [],
        },
      ],
  }),
  mounted() {
    this.loadsCo2();
    this.loadsWeather();
    this.loadsLocation();
    this.intervalFetchData();
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },
  methods: {
    intervalFetchData: function () {
    setInterval(() => {
      if(this.timer == true){     
      this.loadsCo2(),this.loadsWeather()}    
       }, 300000); 
    },
    onResize() {
      this.isMobile = window.innerWidth < 700;
    },
    formatDate(value) {
      return moment(value).format("D MMM YYYY, h:mm:ss a")
    },
    loadsLocation: async function(){
      let apiURL = process.env.VUE_APP_API + "/api/location-air-quality";
      axios.get(apiURL).then(res => {
      this.location = res.data;
      this.locationItem = this.location[0]._id;
      this.loadsCo2();
      this.loadsWeather();
      }).catch(error => {
      console.log(error)
      });
    },
    loadsCo2: async function(){
    let apiURL = process.env.VUE_APP_API + "/api/air-quality/"+ "co2/" + this.locationItem + "/" + this.values1.toDate() + '/'+ this.values2.toDate();
    axios.get(apiURL).then(res => {
    this.airQualityCo2 = res.data;
    this.co2 = res.data.map((co2) => co2.fields.co2);

    let co2Data = this.airQualityCo2.map((e) => {
            return {
              x: e.timestamp,
              y: e.fields.co2,
            };
          });

    this.co2Series = [
            {
              name: "CO2",
              data: co2Data,
            },
          ];

    }).catch(error => {
    console.log(error)
    });
  },

  loadsWeather: async function(){
    let apiURL = process.env.VUE_APP_API + "/api/air-quality/"+ "weather/" + this.locationItem + "/" + this.values1.toDate() + '/'+ this.values2.toDate();
    axios.get(apiURL).then(res => {
    this.airQualityWeather = res.data;
    this.temp = res.data.map((temp) => temp.fields.amb_temp);
    this.humid = res.data.map((humid) => humid.fields.humidity);

    let tempData = this.airQualityWeather.map((e) => {
            return {
              x: e.timestamp,
              y: e.fields.amb_temp,
            };
          });

    this.tempSeries = [
            {
              name: "Temperature",
              data: tempData,
            },
          ];

    let humidData = this.airQualityWeather.map((e) => {
            return {
              x: e.timestamp,
              y: e.fields.humidity,
            };
          });

    this.humidSeries = [
            {
              name: "Humidity",
              data: humidData,
            },
          ];

    }).catch(error => {
    console.log(error)
    });
  },

  updateData(values){
      this.values1 = values[0];
      this.values2 = values[1];
      this.loadsCo2();
      this.loadsWeather();
    },
  updateLocation(){
      this.loadsCo2();
      this.loadsWeather();
    },
  },
  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize, { passive: true });
    }
  },
watch: {
      loader () {
        const l = this.loader
        this[l] = !this[l]

        setTimeout(() => (this[l] = false), 500)

        this.loader = null
      },
    },
}
</script>

